import { service } from '..';

const createKey = ( endpoint, method, urlOption = {}, data = {} ) => `${endpoint}${method}${JSON.stringify( urlOption )}${JSON.stringify( data )}`;
const cache = {};

/**
 * @description Caches the service calls to api
 * @param {string} endPoint A string which specifies the endPoint of an api
 * @param {boolean} override Indicates if the cache should be refreshed
 * @method get
 * @method post
 * @returns {object} The result of the api request
 */
export const cacheService = ( endPoint, override = false ) => ( {
  get( urlOption ) {
    const key = createKey( endPoint, 'get', urlOption );
    if ( !override && cache[key] ) {
      return cache[key];
    }
    return cache[key] = service( endPoint ).get( urlOption );
  },
  post( data, urlOption ) {
    const key = createKey( endPoint, 'post', urlOption, data );
    if ( !override && cache[key] ) {
      return cache[key];
    }
    return cache[key] = service( endPoint ).post( data, urlOption );
  }
} );